import { createElement } from "./PluginCustomProgress";
import intl from "react-intl-universal";

const PluginWaitMask = window.Aliplayer
  ? window.Aliplayer.Component({
      init: function (status: string) {
        this.el = null;
        this.player = null;
        this.dom = null;
        this.status = status;
      },
      createEl: function (el: any, player: any) {
        this.el = el;
        this.player = player;

        this.dom = createElement("div", {
          className: "custom-video-replay",
        });

        // this.dom.innerText = status == 'complete'
        if (this.status == "complete") {
          this.dom.innerText = intl.get("VideoPlaybackGenerating");
        }
        if (this.status == "stop") {
          this.dom.innerText = intl.get("VideoPause");
        }
        if (this.status == "directend") {
          this.dom.innerText = intl.get("VideoDirectEnd");
        }

        this.el.appendChild(this.dom);
      },
    })
  : null;

export default PluginWaitMask;
